import React from 'react';
import ReactDOM from 'react-dom/client';
import ScrollToTop from './components/ScrollToTop';
import EnterAddress from './pages/EnterAddress';
import VerifyProperty from './pages/VerifyProperty';
import ErrorPage from './pages/ErrorPage';
import SignUp from './pages/SignUp';
import Login from './pages/Login';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsAndConditions from './pages/TermsAndConditions';
import Pricing from './pages/Pricing';
import Settings from './pages/Settings';
import Preferences from './pages/Preferences';
import ReportLoading from './pages/ReportLoading';
import GodMode from './pages/GodMode';
// import MissingComps from './pages/MissingComps';
import History from './pages/History';
import GPTWrapper from './pages/GPTWrapper';
import Profile from './pages/Profile';
import TestView from './pages/TestView';
// import Development from './pages/Development';
// import TextLabelling from './labelling/TextLabelling';
// import ImageLabelling from './labelling/ImageLabelling';
import Leaderboard from './pages/Leaderboard';
import RunComps from './pages/RunComps';
import ShareComps from './pages/ShareComps';
import EnterCompanyName from './pages/EnterCompanyName';
import Welcome from './pages/Welcome';
import StripeLink from './pages/StripeLink';
import ImageGPTWrapper from './pages/ImageGPTWrapper';
import GHLSetup from './pages/GHLSetup';
import reportWebVitals from './reportWebVitals';
import mixpanel from 'mixpanel-browser';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { init as initFullStory } from '@fullstory/browser';
// import { PostHogProvider} from 'posthog-js/react';
import './styles/Variables.css';
import './styles/index.css';

initFullStory({ orgId: JSON.parse(process.env.REACT_APP_FULLSTORY).orgId });

// const options = {
// 	api_host: JSON.parse(process.env.REACT_APP_POSTHOG).host
// };

// Initialize Firebase
const app = initializeApp(JSON.parse(process.env.REACT_APP_FIREBASE).config);
getAnalytics(app);

mixpanel.init(JSON.parse(process.env.REACT_APP_MIXPANEL).key, 
	{
		debug: false,
		record_sessions_percent: 100,
		record_collect_fonts: true,
		record_mask_text_selector: ".mask-text",
		record_mask_text_class: ".mask-text",
		record_block_selector: ".mask-text"
	}
);

const routing = (
	<BrowserRouter>
		{/* <PostHogProvider 
			apiKey={JSON.parse(process.env.REACT_APP_POSTHOG).key}
			options={options}
		> */}
			<ScrollToTop>
				<Routes>
					<Route path="/" element={<EnterAddress />} />
					<Route path="/verify-property" element={<VerifyProperty />} />
					<Route path="/sign-up" element={<SignUp />} />
					<Route path="/login" element={<Login />} />
					<Route path="/welcome" element={<Welcome />} />
					<Route path="/company-setup" element={<EnterCompanyName />} />
					<Route path="/privacy-policy" element={<PrivacyPolicy />} />
					<Route path="/terms-conditions" element={<TermsAndConditions />} />
					<Route path="/settings" element={<Settings />} />
					<Route path="/preferences" element={<Preferences />} />
					<Route path="/report-loading" element={<ReportLoading />} />
					<Route path="/demos/:countyId/:id" element={<RunComps />} />
					<Route path="/run-comps/:countyId/:id" element={<RunComps />} />
					<Route path="/run-comps-test/:countyId/:id" element={<TestView />} />
					<Route path="/sample-report" element={<RunComps />} />
					{/* <Route path="/missing-comps" element={<MissingComps />} /> */}
					<Route path="/history" element={<History />} />
					<Route path="/leaderboard" element={<Leaderboard />} />
					<Route path="/pricing" element={<Pricing />} />
					{/* <Route path="/text-labelling" element={<TextLabelling />} /> */}
					{/* <Route path="/image-labelling" element={<ImageLabelling />} /> */}
					<Route path="/comps/:companyId/:countyId/:id" element={<ShareComps />} />
					<Route path="/profile" element={<Profile />} />
					<Route path="/god-mode" element={<GodMode />} />
					<Route path="/stripe-link" element={<StripeLink />} />
					<Route path="/gpt-wrapper" element={<GPTWrapper />} />
					<Route path="/gpt-wrapper-image" element={<ImageGPTWrapper />} />
					<Route path="/crm-setup" element={<GHLSetup />} />
					{/* <Route path="/development" element={<Development />} /> */}

					<Route path="*" element={<ErrorPage />} />
				</Routes>
			</ScrollToTop>
		{/* </PostHogProvider> */}
	</BrowserRouter>
);

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
	  <React.StrictMode>
		  {routing}
	  </React.StrictMode>
);

reportWebVitals();